/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * eCFR SDK
 * TypeScript SDK and Model Context Protocol server for the Electronic Code of Federal Regulations (eCFR) API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiSearchV1ResultsOrder = typeof GetApiSearchV1ResultsOrder[keyof typeof GetApiSearchV1ResultsOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiSearchV1ResultsOrder = {
  citations: 'citations',
  relevance: 'relevance',
  hierarchy: 'hierarchy',
  newest_first: 'newest_first',
  oldest_first: 'oldest_first',
  suggestions: 'suggestions',
} as const;
